// extracted by mini-css-extract-plugin
export default {"container":"RestaurantPage_container__ouk4+","map":"RestaurantPage_map__S4eGe"};